// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/get_non_medical_inventory_price_history.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { NonMedicalInventoryPriceHistoryItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetNonMedicalInventoryPriceHistoryRequest
 */
export class GetNonMedicalInventoryPriceHistoryRequest extends Message<GetNonMedicalInventoryPriceHistoryRequest> {
  /**
   * The ID of the non-medical inventory item for which to retrieve the price history.
   *
   * @generated from field: string inventory_id = 1;
   */
  inventoryId = "";

  constructor(data?: PartialMessage<GetNonMedicalInventoryPriceHistoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetNonMedicalInventoryPriceHistoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inventory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNonMedicalInventoryPriceHistoryRequest {
    return new GetNonMedicalInventoryPriceHistoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNonMedicalInventoryPriceHistoryRequest {
    return new GetNonMedicalInventoryPriceHistoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNonMedicalInventoryPriceHistoryRequest {
    return new GetNonMedicalInventoryPriceHistoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetNonMedicalInventoryPriceHistoryRequest | PlainMessage<GetNonMedicalInventoryPriceHistoryRequest> | undefined, b: GetNonMedicalInventoryPriceHistoryRequest | PlainMessage<GetNonMedicalInventoryPriceHistoryRequest> | undefined): boolean {
    return proto3.util.equals(GetNonMedicalInventoryPriceHistoryRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetNonMedicalInventoryPriceHistoryResponse
 */
export class GetNonMedicalInventoryPriceHistoryResponse extends Message<GetNonMedicalInventoryPriceHistoryResponse> {
  /**
   * The list of price history items for the non-medical inventory item.
   *
   * @generated from field: repeated com.neulink.pharmacy.NonMedicalInventoryPriceHistoryItem price_history = 1;
   */
  priceHistory: NonMedicalInventoryPriceHistoryItem[] = [];

  constructor(data?: PartialMessage<GetNonMedicalInventoryPriceHistoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetNonMedicalInventoryPriceHistoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "price_history", kind: "message", T: NonMedicalInventoryPriceHistoryItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNonMedicalInventoryPriceHistoryResponse {
    return new GetNonMedicalInventoryPriceHistoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNonMedicalInventoryPriceHistoryResponse {
    return new GetNonMedicalInventoryPriceHistoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNonMedicalInventoryPriceHistoryResponse {
    return new GetNonMedicalInventoryPriceHistoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetNonMedicalInventoryPriceHistoryResponse | PlainMessage<GetNonMedicalInventoryPriceHistoryResponse> | undefined, b: GetNonMedicalInventoryPriceHistoryResponse | PlainMessage<GetNonMedicalInventoryPriceHistoryResponse> | undefined): boolean {
    return proto3.util.equals(GetNonMedicalInventoryPriceHistoryResponse, a, b);
  }
}

